import { getInterviewLink } from "../services/medium";
import { logout } from "../services/auth";

// localStorage keys that should survive a session clear (see stepFour.js's
// original moveRoute, which this mirrors).
const PRESERVED_LOCAL_STORAGE_KEYS = ["availabilityNoteClosedAt"];

export const clearSessionPreservingKeys = () => {
  const preserveValues = PRESERVED_LOCAL_STORAGE_KEYS.reduce((acc, key) => {
    const value = localStorage.getItem(key);
    if (value) acc[key] = value;
    return acc;
  }, {});
  localStorage.clear();
  Object.entries(preserveValues).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

/**
 * Fetches this medium's interview-scheduling link, logs them out, and
 * redirects to it in the same window/tab. Shared by the "Book now" popup
 * on the last registration step and the "awaiting approval" notice, so
 * both places behave identically.
 *
 * Resolves once the redirect has been kicked off. Rejects with an Error
 * (whose message is safe to show the user) if no usable link came back.
 */
export const bookInterviewAndRedirect = (id) => {
  return getInterviewLink(id).then((data) => {
    const redirectLink =
      data && data.data && data.data.data && data.data.data.redirect_link;
    const ok = data && data.data && data.data.status && redirectLink;
    if (!ok) {
      const message =
        (data && data.data && data.data.message) ||
        "Unable to get your interview link right now.";
      throw new Error(message);
    }
    let token = localStorage.getItem("access_token");
    return logout(token)
      .catch((err) => {
        console.log(err);
      })
      .then(() => {
        clearSessionPreservingKeys();
        window.location.href = redirectLink;
      });
  });
};
